import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const servicedesk = {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getRequests (date) {
    return  Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/serviceDeskRequests/${date}`)
  },
  getServiceDeskType(){
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/serviceDeskRequests/types`)
  },
  getServiceDeskTypes () {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/serviceDeskRequests/serviceTypes`)
  },
  addServiceDeskType (type) {
    return Axios.post(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/serviceDeskRequests/serviceTypes`, type)
  },
  editServiceDeskType (type) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/serviceDeskRequests/serviceTypes/${type.id}`, type)
  },
  activateServiceDeskType (typeId) {
    return Axios.patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/service-desk-requests/service-types/${typeId}/activate`)
  },
  deactivateServiceDeskType (typeId) {
    return Axios.patch(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/service-desk-requests/service-types/${typeId}/deactivate`)
  }
}

export default servicedesk
